<template>
	<v-skeleton-loader v-if="skeleton" type="card-heading,list-item-two-line,actions"></v-skeleton-loader>
	<v-card v-else v-bind="$attrs" v-on="$listeners">
		<v-card-title v-if="!hideTitle" class="text-left secondaryDark--text font-weight-bold" v-text="$t('addOnAssignCard.title')"></v-card-title>
		<v-card-text>
			<v-alert v-if="value.results.length === 0" text prominent type="info">
				<span v-text="$t('addOnAssignCard.empty')"></span>
			</v-alert>
			<div :key="itemIdx" v-for="(item, itemIdx) in value.results">
				<v-divider v-if="itemIdx > 0" class="my-4" />

				<div class="d-flex align-center justify-content-between">
					<v-icon class="mr-4" x-large>mdi-star-circle-outline</v-icon>

					<h4 style="color: black;" v-text="$t('virtualWalletDetailsCard.balance', {
						type: $options.filters.translatable(item.data.addon_type.name, item.data.addon_type.name_i18n, $i18n.locale),
						//balance: item.data.balance > 0 ? ('+' + item.data.balance) : item.data.balance < 0 ? ('-' + item.data.balance) : item.data.balance,
					})"></h4>
					<strong class="secondaryDark--text" style="margin-left: auto;" >
						<span>
							{{item.data.balance}}
						</span>
					</strong>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { PaginationModel } from '@connectngo/sdk';

export default {
	name: 'AddOnAssignCard',

	props: {
		value: {
			type: PaginationModel,
			default: () => new PaginationModel(),
		},
		skeleton: {
			type: Boolean,
			default: false,
		},
		hideTitle: {
			type: Boolean,
			default: false,
		},
	},
}
</script>
